import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { bind } from '../../../utils/decorators';
import { FormControl, Panel, Table } from 'react-bootstrap';
import { inject } from '../../../utils/decorators';
import { ApiStore } from '../../../stores/ApiStore';
import { VorgangStore } from '../../../stores/VorgangStore';
import { IArbeitsmittel } from '../../../models/ApiTypes';
import { AgtPartikelzaehlerKalibrierungStore } from '../../../stores/AgtPartikelzaehlerKalibrierungStore';
import * as ApiTypesAgtPartikelzaehler from '../../../models/ApiTypesAgtPartikelzaehler';

interface IAgtCMessungMesswertProps {
  ziel: ApiTypesAgtPartikelzaehler.IAgtPartikelzaehlerMesspunkt;
  readOnly: boolean;
  onHandleBlur?: () => void;
}

/** @todo: document */
@observer
class AgtPartikelzaehlerMessungMesswert extends React.Component<IAgtCMessungMesswertProps, {}> {

  @bind @action handleMesswertChanged(ev: React.FormEvent<FormControl>) {
    // @todo: leer / NaN
    this.props.ziel.wert =  (ev.target as HTMLInputElement).valueAsNumber;
  }

  public render() {
    const { onHandleBlur } = this.props;
    return (
      <FormControl type="number" value={this.props.ziel.wert || ''} readOnly={this.props.readOnly} onChange={this.handleMesswertChanged} onBlur={(onHandleBlur) ? () => onHandleBlur() : undefined}/>
    );
  }
}

export interface IAgtPartikelzaehlerMessungProps {
  ziel: ApiTypesAgtPartikelzaehler.IAgtPartikelzaehlerMessreihe;
  nennwert: number;
  value?: string;
  nachjustage: boolean;
}

/** Messwerteingabe für eine Messreihe zur Kalibrierung eines Partikelzählers */
@observer
export default class AgtPartikelzaehlerMessung extends React.Component<IAgtPartikelzaehlerMessungProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;
  @inject(AgtPartikelzaehlerKalibrierungStore) kalibrierungStore: AgtPartikelzaehlerKalibrierungStore;

  @observable validationstate: 'success' | 'warning' | 'error' | undefined = 'error';

  @observable arbeitsmittel: IArbeitsmittel | undefined = undefined;
  @observable gespeichertesArbeitsmittel: string | undefined;

  // private abrufTimeout: number = 0;

  constructor(props: IAgtPartikelzaehlerMessungProps) {
    super(props);
  }

  @action setArbeitsmittel(arbeitsmittel: IArbeitsmittel | undefined) {
    this.arbeitsmittel = arbeitsmittel;
  }

  @bind @action handleArbeitsmittelChanged(ev: React.FormEvent<FormControl>) {
    const arbeitsmittelguid = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).value : undefined;
    if (arbeitsmittelguid && this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
      const arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.find(am => am.arbeitsmittelguid === arbeitsmittelguid);
      this.setArbeitsmittel(arbeitsmittel);
    } else {
      this.setArbeitsmittel(undefined);
    }
  }

  @bind @action handleMesswertChanged(ziel: ApiTypesAgtPartikelzaehler.IAgtPartikelzaehlerMesspunkt, ev: React.FormEvent<FormControl>) {
    // @todo: NaN / empty
    ziel.wert = (ev.target as HTMLInputElement).valueAsNumber;
  }

  @action setBeurteilung(ergebnis: ApiTypesAgtPartikelzaehler.IAgtPartikelzaehlerBeurteilungResponse) {
    for (let i = 0; i < ergebnis.beurteilung.length; i++) {
      this.kalibrierungStore.datensatz.messreihen[i].beurteilung = ergebnis.beurteilung[i].beurteilung;
    }
    if (ergebnis.justage) {
      for (let i = 0; i < ergebnis.justage.beurteilung.length; i++) {
        this.kalibrierungStore.datensatz.messreihenJustage[i].beurteilung = ergebnis.justage.beurteilung[i].beurteilung;
      }
    }
  }

  @bind @action async beurteilungAbrufen() {
    // if (this.abrufTimeout > 0) {
    //   window.clearTimeout(this.abrufTimeout);
    //   this.abrufTimeout = 0;
    // }

    // @todo: debounce
    // @todo: Nur wenn die min. erforderlichen Eingaben gemacht wurden, schöner umsetzen
    // @todo: nicht bei allen Feldern, z.B. bei Partikelgröße nicht notwendig

    const { datensatz } = this.kalibrierungStore;
    var datenVollstaendig: boolean = true;
    for (let i = 0; i < datensatz.messreihen.length; i++) {
      let m = datensatz.messreihen[i];
      if (m.anzeigenormal[0].wert === 0 || m.anzeigenormal[1].wert === 0) {
        datenVollstaendig = false;
        break;
      }
    }

    if (!datenVollstaendig) {
      return;
    }

    const response = await this.apiStore.agtPartikelzaehlerChargingBeurteilung(this.kalibrierungStore.datensatz);
    if (response && response.ok) {
      this.setBeurteilung(response.json);
    }

    // this.abrufTimeout = window.setTimeout( () => { this.beurteilungAbrufen(); }, 500);

    // @todo: prüfen was noch gebraucht wird und auswahl kmg ggf. in Back-End auslagern
    // if ((!this.kraftMessGeraet) || (!this.kalibrierGegenstand) || (!this.kalibrierGegenstand.objekt)) {
    //   return;
    // }
    // this.datensatz.objekt = this.kalibrierGegenstand.objekt.objektguid;
    // this.datensatz.kmg = this.kraftMessGeraet.arbeitsmittelguid;
    // const response = await this.apiStore.bpsReferenzkraftBeurteilungPlatte(this.datensatz);
    // if (response && response.ok) {
    //   this.setBeurteilung(response.json);
    // }
  }

  public render() {
    // @todo: work in progress, finales UI-Layout noch nicht entschieden (vertikal/horizontal/alle Messungen nebeneinander á la BPS)

    let titel: string = 'Messung bei Nennwert ' + this.props.nennwert.toLocaleString() + ' #/cm³';
    if (this.props.nachjustage) {
      titel += ' nach Justage';
    }

    let beurteilung = this.props.ziel.beurteilung !== null ? (this.props.ziel.beurteilung === true ? 'i.O.' : 'n.i.O.') : 'n/a';
    let cssClassName = `agt-dc-beurteilung-${beurteilung.replace(/\./g, '').toLowerCase()}`;

    const { readOnly } = this.kalibrierungStore;

    return(
      <Panel header={titel} collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="agt-auswertung">
          <thead>
            <tr className="tabelle-separator">
              <th style={{textAlign: 'left'}}>Zeitpunkt</th>
              <th>0s</th>
              <th>5s</th>
              <th>10s</th>
              <th>15s</th>
              <th>20s</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colSpan={6}><b>Normale</b></td></tr>
            <tr>
              <td style={{whiteSpace: 'nowrap'}}>Partikelgröße (nm)</td>
              {/* @todo || und 0 (Statt leer), nulish coalescing */}
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.partikelgroesse[0]} readOnly={readOnly} /></td>
              <td/>
              <td/>
              <td/>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.partikelgroesse[1]} readOnly={readOnly} /></td>
            </tr>
            <tr className="tabelle-separator">
              <td style={{whiteSpace: 'nowrap'}}>Anzeige (#/cm³)</td>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.anzeigenormal[0]} readOnly={readOnly} onHandleBlur={this.beurteilungAbrufen} /></td>
              <td/>
              <td/>
              <td/>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.anzeigenormal[1]} readOnly={readOnly} onHandleBlur={this.beurteilungAbrufen} /></td>
            </tr>
            <tr>
              <td colSpan={6}><b>Gerät (Device under Test)</b></td>
              </tr>
            <tr className="tabelle-separator">
              <td style={{whiteSpace: 'nowrap'}}>Anzeige (#/cm³)</td>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.anzeigegeraet[0]} readOnly={readOnly} onHandleBlur={this.beurteilungAbrufen} /></td>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.anzeigegeraet[1]} readOnly={readOnly} onHandleBlur={this.beurteilungAbrufen} /></td>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.anzeigegeraet[2]} readOnly={readOnly} onHandleBlur={this.beurteilungAbrufen} /></td>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.anzeigegeraet[3]} readOnly={readOnly} onHandleBlur={this.beurteilungAbrufen}/></td>
              <td><AgtPartikelzaehlerMessungMesswert ziel={this.props.ziel.anzeigegeraet[4]} readOnly={readOnly} onHandleBlur={this.beurteilungAbrufen} /></td>
            </tr>
            <tr>
              <td colSpan={6} style={{textAlign: 'center'}}>
                <br/>
                Beurteilung: <span className={cssClassName} style={{textAlign: 'right'}}>{beurteilung}</span>
              </td>
            </tr>
          </tbody>
        </Table>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/agt/AgtPartikelzaehlerMessung.tsx